export interface InputConfig {
    placeholder?: string;
    inputType?: string;
    maxLength?: number;
}

export interface CounterConfig {
    min?: number;
    max?: number;
}

export interface FieldOption {
    option: string;
    fileId?: string;
    imageUrl?: string;
    iconId?: string;
}

/**
 * Estructura de un campo del formulario dinámico de una subcategoría.
 * Es la misma estructura que consume el app móvil (subcategory_fields JSONB).
 */
export interface FormField {
    name: string;
    type: string;
    fieldTitle?: string;
    fieldDescription?: string;
    priority?: number;
    required?: boolean;
    uiRole?: string;        // parent | child | standalone
    uiGroupHint?: string;   // solo | paired | flex
    inputConfig?: InputConfig;
    detailTitle?: string;
    detailIcon?: string;
    options?: FieldOption[];
    dependencies?: { [answer: string]: FormField[] } | null;
    confirmText?: string;
    cancelText?: string;
    neutralText?: string;
    counterConfig?: CounterConfig;
}

export const FIELD_TYPES: { value: string; label: string }[] = [
    { value: 'input_text', label: 'Texto corto' },
    { value: 'input_text_area', label: 'Área de texto' },
    { value: 'select', label: 'Lista desplegable' },
    { value: 'multiselect', label: 'Selección múltiple' },
    { value: 'radio', label: 'Opción única (radio)' },
    { value: 'checkbox', label: 'Checkbox' },
    { value: 'confirmation', label: 'Confirmación (Sí/No)' },
    { value: 'counter', label: 'Contador' },
    { value: 'photos', label: 'Fotos' }
];

/** Tipos de campo que manejan opciones */
export const OPTION_FIELD_TYPES = ['select', 'multiselect', 'radio', 'checkbox'];

/** Tipos de campo que pueden tener dependencias por respuesta */
export const DEPENDENCY_FIELD_TYPES = ['confirmation', 'radio', 'select'];

export interface AdminSubcategory {
    subcategoryId?: string;
    subcategoryName: string;
    active?: boolean;
    categoryId?: string;
    imageTitleFileId?: string;
    imageTitleUrl?: string;
    imageIconFileId?: string;
    imageIconUrl?: string;
    fields?: FormField[];
}

export interface AdminCategory {
    categoryId?: string;
    categoryName: string;
    active?: boolean;
    iconName?: string;
    backgroundColor?: string;
    imageFileId?: string;
    imageUrl?: string;
    subcategories?: AdminSubcategory[];
}

export interface UploadImageResponse {
    fileId: string;
    url: string;
}

export type ImageType = 'category-icons' | 'subcategory-icons' | 'subcategory-images' | 'option-icons';
